/** Pivot tabs on the storefront products page, addressable via the `tab` query parameter. */
export const STOREFRONT_PRODUCTS_TABS = {
    settings: 'settings',
    attributes: 'attributes',
    products: 'products',
    savedSearches: 'savedSearches',
    bundles: 'bundles',
    promotions: 'promotions',
} as const;

export type StorefrontProductsTab = typeof STOREFRONT_PRODUCTS_TABS[keyof typeof STOREFRONT_PRODUCTS_TABS];

/**
 * Path to a storefront's products page, optionally deep-linked to one of its tabs.
 *
 * Built here rather than inline at each call site so the route and its tab keys stay in one place —
 * completion toasts link straight to the Products tab, while the settings navigation lands on the
 * page's default tab.
 */
export const storefrontProductsPath = (storefrontId: string, tab?: StorefrontProductsTab): string =>
    `/settings/storefront/storefronts/${storefrontId}/products${tab ? `?tab=${tab}` : ''}`;
